import React, { Component } from 'react';
import * as PropTypes from 'prop-types';

import './MultiSettingsInput.scss';

export default class MultiSettingsInput extends Component {
  getValue = (setting, name) => {
    if (this.props.values.hasOwnProperty(setting)) {
      return this.props.values[setting][name] || '';
    } else {
      return '';
    }
  };

  onChange = (setting, schema, e) => {
    let inputValue = e.target.value;

    if (e.target.type === 'checkbox') {
      inputValue = e.target.checked ? true : false;
    }

    let allSettings = this.props.values;
    if (!allSettings.hasOwnProperty(setting)) {
      allSettings[setting] = {};
    }
    allSettings[setting][schema.name] = inputValue;

    this.props.changeValue(this.props.name, allSettings);
    this.forceUpdate(); // force a re-render of the component
  };

  renderSettingInput = (schema, setting, disabled) => {
    let value = this.getValue(setting.name, schema.name);
    if (schema.type === 'radio') {
      return (
        <input
          type="radio"
          name={setting.name + '-' + schema.name}
          disabled={disabled}
          onChange={(e) => this.onChange(setting.name, schema, e)}
          value={schema.value}
          checked={value === schema.value}
        />
      );
    } else if (schema.type === 'checkbox') {
      return (
        <input
          type="checkbox"
          name={setting.name + '-' + schema.name}
          disabled={disabled}
          onChange={(e) => this.onChange(setting.name, schema, e)}
          checked={value === true || value === 1}
        />
      );
    } else {
      return <span>???</span>;
    }
  };

  render() {
    return (
      <table className="table table-condensed multi-settings">
        <thead>
          <tr>
            <th>
              <div>
                <span>{this.props.label}</span>
              </div>
            </th>
            {this.props.schema.map((schema) => (
              <th key={schema.label} className="rotate">
                <div>
                  <span>{schema.label}</span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {this.props.settings.map((setting) => (
            <tr key={setting.name}>
              <td>{setting.label}</td>
              {this.props.schema.map((schema) => (
                <td key={schema.label}>
                  {this.renderSettingInput(
                    schema,
                    setting,
                    this.props.disabled
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

MultiSettingsInput.defaultProps = {
  node: '',
  name: '',
  label: '',
  disabled: false,
  schema: [],
  settings: [],
  values: {},
};

MultiSettingsInput.propTypes = {
  name: PropTypes.string.isRequired,
  node: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  schema: PropTypes.arrayOf(PropTypes.object),
  settings: PropTypes.array,
  values: PropTypes.object,
};
